// Every locale file is imported explicitly so bundling and `node --test` both see it.
// Adding a namespace: add its name to NAMESPACES, then one import per language below.
// Filling an existing namespace only means editing its JSON.

import vi_common from './locales/vi/common.json' with { type: 'json' };
import vi_login from './locales/vi/login.json' with { type: 'json' };
import vi_layout from './locales/vi/layout.json' with { type: 'json' };
import vi_setup from './locales/vi/setup.json' with { type: 'json' };
import vi_home from './locales/vi/home.json' with { type: 'json' };
import vi_questionBank from './locales/vi/questionBank.json' with { type: 'json' };
import vi_qbEditor from './locales/vi/qbEditor.json' with { type: 'json' };
import vi_panels from './locales/vi/panels.json' with { type: 'json' };
import vi_quiz from './locales/vi/quiz.json' with { type: 'json' };
import vi_exams from './locales/vi/exams.json' with { type: 'json' };
import vi_ai from './locales/vi/ai.json' with { type: 'json' };
import vi_board from './locales/vi/board.json' with { type: 'json' };
import vi_whiteboard from './locales/vi/whiteboard.json' with { type: 'json' };
import vi_attendance from './locales/vi/attendance.json' with { type: 'json' };
import vi_conduct from './locales/vi/conduct.json' with { type: 'json' };
import vi_library from './locales/vi/library.json' with { type: 'json' };
import vi_courses from './locales/vi/courses.json' with { type: 'json' };
import vi_documents from './locales/vi/documents.json' with { type: 'json' };
import vi_update from './locales/vi/update.json' with { type: 'json' };
import vi_errors from './locales/vi/errors.json' with { type: 'json' };

import en_common from './locales/en/common.json' with { type: 'json' };
import en_login from './locales/en/login.json' with { type: 'json' };
import en_layout from './locales/en/layout.json' with { type: 'json' };
import en_setup from './locales/en/setup.json' with { type: 'json' };
import en_home from './locales/en/home.json' with { type: 'json' };
import en_questionBank from './locales/en/questionBank.json' with { type: 'json' };
import en_qbEditor from './locales/en/qbEditor.json' with { type: 'json' };
import en_panels from './locales/en/panels.json' with { type: 'json' };
import en_quiz from './locales/en/quiz.json' with { type: 'json' };
import en_exams from './locales/en/exams.json' with { type: 'json' };
import en_ai from './locales/en/ai.json' with { type: 'json' };
import en_board from './locales/en/board.json' with { type: 'json' };
import en_whiteboard from './locales/en/whiteboard.json' with { type: 'json' };
import en_attendance from './locales/en/attendance.json' with { type: 'json' };
import en_conduct from './locales/en/conduct.json' with { type: 'json' };
import en_library from './locales/en/library.json' with { type: 'json' };
import en_courses from './locales/en/courses.json' with { type: 'json' };
import en_documents from './locales/en/documents.json' with { type: 'json' };
import en_update from './locales/en/update.json' with { type: 'json' };
import en_errors from './locales/en/errors.json' with { type: 'json' };

export const NAMESPACES = [
  'common',
  'login',
  'layout',
  'setup',
  'home',
  'questionBank',
  'qbEditor',
  'panels',
  'quiz',
  'exams',
  'ai',
  'board',
  'whiteboard',
  'attendance',
  'conduct',
  'library',
  'courses',
  'documents',
  'update',
  'errors',
] as const;

export type Namespace = (typeof NAMESPACES)[number];

export const viResources = {
  common: vi_common,
  login: vi_login,
  layout: vi_layout,
  setup: vi_setup,
  home: vi_home,
  questionBank: vi_questionBank,
  qbEditor: vi_qbEditor,
  panels: vi_panels,
  quiz: vi_quiz,
  exams: vi_exams,
  ai: vi_ai,
  board: vi_board,
  whiteboard: vi_whiteboard,
  attendance: vi_attendance,
  conduct: vi_conduct,
  library: vi_library,
  courses: vi_courses,
  documents: vi_documents,
  update: vi_update,
  errors: vi_errors,
};

export const enResources = {
  common: en_common,
  login: en_login,
  layout: en_layout,
  setup: en_setup,
  home: en_home,
  questionBank: en_questionBank,
  qbEditor: en_qbEditor,
  panels: en_panels,
  quiz: en_quiz,
  exams: en_exams,
  ai: en_ai,
  board: en_board,
  whiteboard: en_whiteboard,
  attendance: en_attendance,
  conduct: en_conduct,
  library: en_library,
  courses: en_courses,
  documents: en_documents,
  update: en_update,
  errors: en_errors,
};

export const resources = {
  vi: viResources,
  en: enResources,
};
